import { Button } from '@act/storybook';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { useEffect, useState } from 'react';
import { filesRequests } from 'redux/requests/files.requests';
import { FileState, loadFile, selectFilesMap } from 'redux/slices/filesSlice';
import { useAppDispatch, useAppSelector } from 'redux/store-hooks';
import { useApiCall } from 'redux/utils/api-hook';
import { getToken } from 'redux/utils/firebase-auth';
import styled from 'styled-components';
import ViewFile from './view-file';
import ViewFileDialog from './view-file-dialog';

const FilePreviewer = (props: { filedId: string }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useAppDispatch();
  const fileDetail: FileState = useAppSelector(selectFilesMap)[props.filedId];
  const [token, setToken] = useState('');
  const [signedUrl, _loadingSignedUrl, getSignedUrl] = useApiCall(
    filesRequests.getSignedUrl
  );

  useEffect(() => {
    dispatch(loadFile({ id: props.filedId }));
  }, [props.filedId]);
  useEffect(() => {
    async function asyncGetToken() {
      const token = await getToken();
      setToken(token);
    }
    if (!token) {
      void asyncGetToken();
    }
  }, []);

  useEffect(() => {
    const mimeType = fileDetail?.file?.mimeType;
    if (
      !signedUrl &&
      fileDetail?.id &&
      mimeType &&
      (mimeType.startsWith('image/') || mimeType.startsWith('application/pdf'))
    ) {
      getSignedUrl({
        params: { id: fileDetail.id },
      });
    }
  }, [fileDetail]);

  if (!fileDetail && !signedUrl?.temporaryUrl) {
    return <ThumbnailDiv>No file</ThumbnailDiv>;
  } else if (fileDetail?.loadingStatus === 'loading') {
    return <ThumbnailDiv>Loading...</ThumbnailDiv>;
  }

  const file = fileDetail?.file;

  if (!file) {
    return <ThumbnailDiv>No file</ThumbnailDiv>;
  }

  const handleClose = () => setDialogOpen(false);
  const dialog = (
    <ViewFileDialog file={file} open={dialogOpen} onClose={handleClose} />
  );

  if (file?.mimeType?.startsWith('video/')) {
    return (
      <ThumbnailDiv $clickable={true}>
        <Button onClick={() => setDialogOpen(true)}>
          <OndemandVideoIcon />
        </Button>
        {dialog}
      </ThumbnailDiv>
    );
  } else if (file?.mimeType?.startsWith('audio/')) {
    return <ViewFile file={file}></ViewFile>;
  } else if (file?.mimeType?.startsWith('image/')) {
    return (
      <ThumbnailDiv $clickable={true}>
        <img
          src={signedUrl?.temporaryUrl}
          onClick={() => setDialogOpen(true)}
        ></img>
        {dialog}
      </ThumbnailDiv>
    );
  } else {
    return (
      <ThumbnailDiv $clickable={true}>
        <Button onClick={() => setDialogOpen(true)}>
          <InsertDriveFileOutlinedIcon />
        </Button>
        {dialog}
      </ThumbnailDiv>
    );
  }
};

const ThumbnailDiv = styled.div<{ $clickable?: boolean }>`
  height: 100%;
  max-width: 100%;
  ${props => (props.$clickable ? 'cursor: pointer;' : '')}
  img {
    height: 100%;
    max-width: 100%;
  }
`;

export default FilePreviewer;
